'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withParams2.default)({ type: 'alpha' }, function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return (/^[a-zA-Z]*$/.test(value)
  );
});


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/alpha.js
// module id = 775
// module chunks = 0